// Formular-Bausteine (Musterkatalog M-002, Design-Guide `formularfelder.md`).
// Paket F1: Feld, Textfeld, Mehrzeiler, Auswahl, Hinweissatz, Datumsfeld, Passwortfeld, Suchfeld, Schalter,
// Kontrollkästchen (`Kontrollkaestchen`), Optionsgruppe.
export { Feld, FeldHuelle, feldIds, useFeldId, type FeldAttribute, type FeldEigenschaften, type FeldGroesse, type FeldLayout } from "./feld";
// M-060 Feldhilfe: „?“ am Label (über `Feld`/`feldhilfe`) und „am Wort“ (`Kurzhilfe`, M-012 KF6).
export { Feldhilfe, Kurzhilfe, type FeldhilfeInhalt } from "./feldhilfe";
export { Textfeld, Datumsfeld, Suchfeld, type TextfeldArt } from "./textfeld";
export { Mehrzeiler } from "./mehrzeiler";
export { Auswahl, type AuswahlOption, type AuswahlGruppe } from "./auswahl";
export { Hinweissatz } from "./rueckmeldung";
export { Passwortfeld } from "./passwortfeld";
export { Schalter, Schalterliste, Kontrollkaestchen, type SchalterLayout } from "./schalter";
export { Fortschrittsschieber } from "./fortschrittsschieber";
export { Optionsgruppe, type OptionsgruppeOption } from "./optionsgruppe";
// Brötchen-Vorbestellung B1 (Spec 2026-10-20): mehrere Tage einer Woche wählen (Serie von Ausgabefenstern).
export { TagWahl, type TagWahlOption } from "./tag-wahl";
export { WahlKarten, type WahlKarteOption } from "./wahl-karten";
// Betreiber 12.10.2026 (K2 + D1): Dauer als Segment + freier Wert, Endzeitzeile; Beginn = `Datumsfeld art="zeit"`.
export { Dauerwahl, Endzeitzeile, type DauerwahlEigenschaften } from "./dauerwahl";
// Paket F2: AuswahlErweitert, PersonenAuswahl (P1/P3/P4), TagAuswahl, Trefferfeld, Dateifeld.
export { AuswahlErweitert, HsAuswahl, SUCHE_AB, type AuswahlErweitertEigenschaften } from "./erweiterte-auswahl";
export { PersonenAuswahl, personenOptionen, type Person, type PersonenRolle, type PersonenAuswahlEigenschaften } from "./personen-auswahl";
export { TagAuswahl, type TagOption } from "./tag-auswahl";
export { TagFarbwahl, type TagFarbwahlOption } from "./tag-farbwahl";
export { Trefferfeld, type Treffer } from "./trefferfeld";
export { Dateifeld } from "./dateifeld";
export { Dateiauswahl } from "./dateiauswahl";
export { DateiAblage, useDateiZiehen } from "./datei-ablage";
export { setzeRolle, entferne, type Beteiligung, type BeteiligteRegel, type BeteiligteAenderung } from "./beteiligte-regeln";
export { baueAuswahlKonfiguration, esc, initialen, personSymbolHtml, tagSymbolHtml, TAG_PUNKT, type HsOption, type HsModus, type TagFarbe } from "./auswahl-konfiguration";
// M-011 (Aufgaben-Detail): Composer mit @-Liste und seine reine Logik.
export { Composer, type ComposerErgebnis } from "./composer";
// M-094 (Wissens-Assistent P2): Eingabe des Verlaufs mit Anhängen, Ziehen, Diktat-Platz und Senden/Stopp.
export { ChatEingabe } from "./chat-eingabe";
export { erwaehnungsAbfrage, filtereErwaehnbare, serialisiereErwaehnungen, type ErwaehnbarePerson } from "./composer-logik";
